module.exports = __webpack_public_path__ + "static/santeboutiquecut-f584f6ef1898cbc3fcd03a1b882bcaae.png";